import { Instagram, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.18 8.18 0 004.77 1.52V6.84a4.84 4.84 0 01-1-.15z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-secondary/95 marble-texture text-secondary-foreground py-20">
      <div className="container mx-auto px-6 text-center">
        <h3 className="font-serif text-3xl mb-2 italic">Cuts By Cate</h3>
        <p className="font-sans text-[11px] font-bold tracking-[0.3em] uppercase opacity-40 mb-10">
          Tulsa, Oklahoma
        </p>

        <div className="flex justify-center gap-8 mb-12">
          <a href="https://www.instagram.com/cutsbycate?igsh=MWUyenRmb2htMjA3Nw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="opacity-40 hover:opacity-100 transition-opacity duration-300">
            <Instagram size={18} />
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="opacity-40 hover:opacity-100 transition-opacity duration-300">
            <TikTokIcon />
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="opacity-40 hover:opacity-100 transition-opacity duration-300">
            <Facebook size={18} />
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="opacity-40 hover:opacity-100 transition-opacity duration-300">
            <Youtube size={18} />
          </a>
        </div>

        <div className="w-16 h-px bg-secondary-foreground/10 mx-auto mb-10" />

        <div className="flex justify-center gap-10 text-[10px] font-sans font-bold tracking-[0.25em] uppercase opacity-40">
          <Link to="/portfolio" className="hover:opacity-100 transition-opacity duration-300">Portfolio</Link>
          <Link to="/services" className="hover:opacity-100 transition-opacity duration-300">Services</Link>
          <Link to="/book" className="hover:opacity-100 transition-opacity duration-300">Book</Link>
        </div>

        <p className="mt-12 text-[10px] opacity-25 font-sans tracking-wider">
          © {new Date().getFullYear()} Cuts By Cate. All rights reserved.
          <span className="mx-2">·</span>
          <Link to="/admin/login" className="hover:opacity-100 transition-opacity duration-300">Admin</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;